var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('moduleTitle',{staticClass:"bottom",attrs:{"title":"填写简历"}}),_c('resumeInfo',{attrs:{"disabled":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }